module.exports = __webpack_public_path__ + "img/background-service.fe9fbd19.png";